module.exports = __webpack_public_path__ + "img/20.a7719e5e.png";